const MAX_NAME_LENGTH = 100;

/* Names cameras, phones and screenshot tools give files, which say nothing about the item. */
const GENERIC_NAMES = [
  /^img[\s_-]?\d+/i,
  /^dsc[\s_-]?\d+/i,
  /^pxl[\s_-]\d+/i,
  /^photo[\s_-]?\d+/i,
  /^screenshot\b/i,
  /^screen shot\b/i,
  /^image(\s*\(\d+\))?$/i,
  /^\d+$/,
];

const withoutExtension = (fileName) => fileName.replace(/\.[^.]+$/, "");

const capitalised = (text) => text.charAt(0).toUpperCase() + text.slice(1);

export const nameFromFile = (fileName) => {
  const base = withoutExtension(fileName).trim();
  const words = base
    .replace(/[._-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return GENERIC_NAMES.some((pattern) => pattern.test(base))
    ? ""
    : capitalised(words).slice(0, MAX_NAME_LENGTH);
};

export const centreCropOf = ({ width, height, aspectRatio }) => {
  const isWider = width / height > aspectRatio;
  const cropWidth = isWider ? Math.round(height * aspectRatio) : width;
  const cropHeight = isWider ? height : Math.round(width / aspectRatio);

  return {
    x: Math.floor((width - cropWidth) / 2),
    y: Math.floor((height - cropHeight) / 2),
    width: cropWidth,
    height: cropHeight,
  };
};
